export function describeToggleResult(response) {
  if (response.status !== 204) {
    return { severity: 'error', message: 'Ocorreu um problema. Verifique os dados.' }
  }

  if (response.logFailed) {
    return { severity: 'warning', message: 'Alterado, mas não foi possível registrar o log do motivo.' }
  }

  return { severity: 'success', message: 'Alterado.' }
}
